import React from "react";
import "./index.css";

const RoundedButton = ({ className = "", ...rest }) => (
  <input type="button" className={`rounded-button  ${className}`} {...rest} />
);

export default RoundedButton;



// WEBPACK FOOTER //
// ./src/components/RoundedButton/index.js